import React, { useState, useEffect } from 'react';
import './TemplateSaveModal.css';

function TemplateSaveModal({
    isOpen,
    title = "Enregistrer le modèle",
    defaultName = "Nouveau modèle",
    defaultDescription = "",
    onConfirm,
    onCancel
}) {
    const [name, setName] = useState(defaultName);
    const [description, setDescription] = useState(defaultDescription);

    useEffect(() => {
        if (isOpen) {
            setName(defaultName);
            setDescription(defaultDescription);
        }
    }, [isOpen, defaultName, defaultDescription]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm({
            name,
            description,
            category: 'custom',
            isPublic: false
        });
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal-content template-save-modal" onClick={(e) => e.stopPropagation()}>
                <h3>{title}</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="template-name">Nom du modèle *</label>
                        <input
                            id="template-name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Entrez le nom du modèle"
                            required
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="template-description">Description</label>
                        <textarea
                            id="template-description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Décrivez le modèle (optionnel)"
                            rows={3}
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn-secondary" onClick={onCancel}>
                            Annuler
                        </button>
                        <button type="submit" className="btn-primary">
                            Enregistrer
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default TemplateSaveModal;
